import React from 'react';
import { FormulaContainer } from './styled';

interface IProps {
  formula?: string;
}
const FormulaBlock = (props: IProps) => {
  const { formula } = props;

  return (
    <FormulaContainer>
      {formula ? (
        <div>
          <span>Fórmula:</span> <div>{formula}</div>
        </div>
      ) : (
        <div>
          <span>Fórmula:</span> <div>No se han encontrado datos.</div>
        </div>
      )}
    </FormulaContainer>
  );
};

export default FormulaBlock;
